import {
    IonAvatar,
    IonCol, 
    IonIcon,
    IonImg,
    IonItem,
    IonLabel,
    IonNote,
    IonRow,
    IonThumbnail,
    useIonRouter
} from '@ionic/react';
import { thumbsUpSharp, thumbsDownSharp } from 'ionicons/icons';
import { CommentLikeDetail } from '../data/item';
import React, { Component }  from 'react';

interface CommentLikeProp {
    like : CommentLikeDetail;
    onClick : any;
}
  
const CommentLike: React.FC<CommentLikeProp> = ({ like, onClick }) => {
    
    return (
        <IonItem onClick={()=> onClick(like) } detail={false} lines="none">
            <IonAvatar slot="start">
                <img src={like.avatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
            </IonAvatar>
            <IonLabel className="ion-text-wrap">
                <h2>{like.name}</h2>
            </IonLabel>
            <IonIcon slot="end" icon={ like.like == 1 ? thumbsUpSharp : thumbsDownSharp }/>
        </IonItem>
    );
};
  
export default CommentLike;